import React, { useState, useRef } from "react";
import "./Header.css";
import { Link } from "react-router-dom";

function Header() {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [fullName, setFullName] = useState("");
  const [category, setCategory] = useState("");
  const [isConstitutionModalOpen, setIsConstitutionModalOpen] = useState(false); // Constitution Modal State
  const [isCodeOfConductModalOpen, setIsCodeOfConductModalOpen] = useState(false); // Code of Conduct Modal State
  const [isRegistrationModalOpen, setIsRegistrationModalOpen] = useState(false); // Registraion Modal State
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false); // Member Serach Modal State
  const [email, setEmail] = useState(""); 
  const timeoutRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for:", fullName, category);
    // Add logic to handle the search
  };

  const handleMouseEnter = (menu) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setActiveMenu(menu);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveMenu(null);
    }, 200);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Constitution Modal Handlers
  const openConstitutionModal = () => {
    setIsConstitutionModalOpen(true);
  };

  const closeConstitutionModal = () => {
    setIsConstitutionModalOpen(false);
    setEmail(""); // Clear email input on close
  };

  // Code of Conduct Modal Handlers
  const openCodeOfConductModal = () => {
    setIsCodeOfConductModalOpen(true);
  };

  const closeCodeOfConductModal = () => {
    setIsCodeOfConductModalOpen(false);
    setEmail(""); // Clear email input on close
  };

  // Registraion Modal Handlers
  const openRegistrationModal = () => {
    setIsRegistrationModalOpen(true);
  };

  const closeRegistrationModal = () => {
    setIsRegistrationModalOpen(false);
    setEmail(""); // Clear email input on close
  };

  // Meamber Search Modal Handlers
   const openSearchModal = () => {
    setIsSearchModalOpen(true);};

  const closeSearchModal = () => {
    setIsSearchModalOpen(false);
    setEmail(""); // Clear email input on close
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleDownload = (filePath, fileName) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      // Trigger download (adjust file path as necessary)
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      link.click();
      setIsConstitutionModalOpen(false);
      setIsCodeOfConductModalOpen(false);
      setIsRegistrationModalOpen(false);
    } else {
      alert("Please enter a valid email address.");
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-left">
          <Link to="/">
          <img
            src="/images/logo.png"
            alt="Actuarial Society Logo"
            className="logo"
          />
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? "×" : "☰"} {/* Hamburger to X */}
        </button>
        <div className="menu-item">
          <nav className={`header-nav ${menuOpen ? "open" : ""}`}>
            <ul>


              <li
                className={`dropdown ${activeMenu === "about" ? "active" : ""}`}
                onMouseEnter={() => handleMouseEnter("about")}
                onMouseLeave={handleMouseLeave}
              >
                The ASG
                <span
                  className={`arrow ${
                    activeMenu === "about" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "about" ? "show" : ""
                  }`}
                >
                  <li>
                    <Link className="link" to="/about-asg">
                    <i class="fas fa-info-circle mr-2"></i>&nbsp; About ASG
                    </Link>
                  </li>
                  <li>
                    <Link className="link" to="/council">
                    <i class="fas fa-university mr-2"></i>&nbsp; The Council
                    </Link>
                  </li>
                  <li>
                    <Link className="link" to="/executives"> 
                    <i class="fas fa-users mr-2"></i>&nbsp; Executives
                    </Link>
                  </li>
                  <li className="link" onClick={openConstitutionModal} style={{ cursor: "pointer" }}> 
                  <i class="fas fa-file mr-2"></i>&nbsp; Our Constitution
                  </li>
                  <li className="link" onClick={openCodeOfConductModal} style={{ cursor: "pointer" }}>
                  <i class="fas fa-code mr-2"></i>&nbsp; Code of Conduct
                  </li>
                </ul>
              </li>

              <li
                className={`dropdown ${
                  activeMenu === "membership" ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter("membership")}
                onMouseLeave={handleMouseLeave}
              >
                Membership
                <span
                  className={`arrow ${
                    activeMenu === "membership" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "membership" ? "show" : ""
                  }`}
                >
                  <li className="link" onClick={openRegistrationModal} style={{ cursor: "pointer" }}>
                    <i class="fas fa-check-circle mr-2"></i>&nbsp; Registration
                  </li>
                  <li>
                    <Link className="link" to="/categories">
                  <i class="fas fa-sitemap mr-2"></i>&nbsp; Categories
                  </Link>
                  </li>
                  <li>
                    <Link className="link" to="/membershipfeetable">
                  <i class="fas fa-money-check-alt mr-2"></i>&nbsp; Subscription Fees
                  </Link>
                  </li>
                  <li>
                  <Link className="link" to="/pas-licenses">
                  <i class="fas fa-certificate mr-2"></i>&nbsp; PAS (Licenses)
                  </Link>
                  </li>
                  <li className="link"  onClick={openSearchModal}  style={{ cursor: "pointer" }}>
                    
                  </li>
                </ul>
              </li>
              <li
                className={`dropdown ${
                  activeMenu === "education" ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter("education")}
                onMouseLeave={handleMouseLeave}
              >
                Education
                <span
                  className={`arrow ${
                    activeMenu === "education" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "education" ? "show" : ""
                  }`}
                >
                  <li>
                      <Link className="link" to="/asgpathway">
                      <i class="fas fa-route mr-2"></i>&nbsp; ASG Pathway
                      </Link>
                  </li>
                  <li><i class="fas fa-calendar-alt mr-2"></i>&nbsp; ASG-GIC Programme</li>
                  <li>
                      <Link className="link" to="/key-timelines">
                          <i class="fas fa-book mr-2"></i>&nbsp; Key Timelines
                      </Link>
                  </li>
                  <li>
                    <Link className="link" to="/accrediteduniversities">
                    <i class="fas fa-university mr-2"></i>&nbsp; Accreditation & Exemptions
                    </Link>
                  </li>
                  <li>
                    <Link className="link" to="/past-questions">
                    <i class="fas fa-question-circle mr-2"></i>&nbsp; Past Questions
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={`dropdown ${
                  activeMenu === "asgConnect" ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter("asgConnect")}
                onMouseLeave={handleMouseLeave}
              >
                Event & CPD
                <span
                  className={`arrow ${
                    activeMenu === "asgConnect" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "asgConnect" ? "show" : ""
                  }`}
                > 
                 <li>
                    <Link className="link" to="/asg-conference2025">
                    <i class="fas fa-clock mr-2"></i>&nbsp; ASG Conferences
                    </Link>
                  </li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; CPD events</li>
                </ul>
              </li>
              <li
                className={`dropdown ${
                  activeMenu === "publication" ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter("publication")}
                onMouseLeave={handleMouseLeave}
              >
                Publications
                <span
                  className={`arrow ${
                    activeMenu === "publication" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "publication" ? "show" : ""
                  }`}
                >
                  <li>
                    <Link className="link" to="/jobs">
                    <i class="fas fa-clock mr-2"></i>&nbsp; Actuarial Jobs
                    </Link>
                  </li>
                  <li>
                    <Link className="link" to="/conference-papers">
                    <i class="fas fa-clock mr-2"></i>&nbsp; Conference Papers
                    </Link>
                  </li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; Industry Papers</li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; Journals Papers</li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; Academic Research</li>
                </ul>
              </li>
              <li
                className={`dropdown ${
                  activeMenu === "ourProject" ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter("ourProject")}
                onMouseLeave={handleMouseLeave}
              >
                Our Project
                <span
                  className={`arrow ${
                    activeMenu === "ourProject" ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
                <ul
                  className={`dropdown-menu ${
                    activeMenu === "ourProject" ? "show" : ""
                  }`}
                >
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; GAT Project</li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; ASG-D Funding Support</li>
                  <li>
                    <Link className="link" to="/MortalityTable">
                    <i class="fas fa-clock mr-2"></i>&nbsp; ASG-GiA Mortality Tables
                    </Link>
                  </li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; UNDP-Milliman GAIN</li>
                  <li><i class="fas fa-clock mr-2"></i>&nbsp; NACDev Project</li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>

        <button className="login-btn">Member Login</button>
      

        {/* Constitution Modal */}
        {isConstitutionModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <img
                src="/images/download-icon.png"
                alt="Download"
                className="modal-icon"
              />
              <h2>Download ASG Constitution</h2>
              <p>Enter your email to proceed with downloading the ASG Constitution.</p>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                className="modal-input"
              />
              <div className="modal-buttons">
                <button className="btn-cancel" onClick={closeConstitutionModal}>
                  Cancel
                </button>
                <button
                  className="btn-proceed"
                  onClick={() => handleDownload("/files/ASG CONSTITUTION_2017.pdf", "ASG_Constitution.pdf")}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Code of Conduct Modal */}
        {isCodeOfConductModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <img
                src="/images/download-icon.png"
                alt="Download"
                className="modal-icon"
              />
              <h2>Download ASG Code of Conduct</h2>
              <p>Enter your email to proceed with downloading the ASG Code of Conduct.</p>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                className="modal-input"
              />
              <div className="modal-buttons">
                <button className="btn-cancel" onClick={closeCodeOfConductModal}>
                  Cancel
                </button>
                <button
                  className="btn-proceed"
                  onClick={() => handleDownload("/files/code-of-conduct.pdf", "ASG_Code_of_Conduct.pdf")}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        )}

                {/* Registration Modal */}
                {isRegistrationModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <img
                src="/images/download-icon.png"
                alt="Download"
                className="modal-icon"
              />
              <h2>Download Registraion Form</h2>
              <p>Enter your email to proceed with downloading the Registraion Form.</p>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                className="modal-input"
              />
              <div className="modal-buttons">
                <button className="btn-cancel" onClick={closeRegistrationModal}>
                  Cancel
                </button>
                <button
                  className="btn-proceed"
                  onClick={() => handleDownload("/files/ASG Membership Application Form.pdf", "Application_Form.pdf")}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        )}

                        {/* Member Search Modal */}
        {isSearchModalOpen && (
          <div className="modal-overlay">
              <div className="search-member-container">
              <h2>Search for a Member</h2>
              <form onSubmit={handleSearch} className="search-form">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    id="fullName"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    placeholder="Enter full name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="category">Membership Category</label>
                  <select
                    id="category"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                  >
                    <option value="">Select a category</option>
                    <option value="student">Student</option>
                    <option value="associate">Associate</option>
                    <option value="fellow">Fellow</option>
                    <option value="affiliate">Affiliate</option>
                  </select>
                </div>
                <div className="modal-buttons">
                <button className="btn-cancel" onClick={closeSearchModal}>
                  Cancel
                </button> 
                <button type="submit" className="search-button">
                  Search Member
                </button>
              </div>
               
              </form>
            </div>
          </div>
        )}

      </header>
    </>
  );
}

export default Header;